import Icon, { COLORS, ICONS } from '../../../../../../general-ui/icon';
import PanelHeader from "../../panel/headers/panel-header";
import { EventsState } from '../../../../../../../store/types';
import { useSelector, useDispatch } from 'react-redux';
import Colors from '../../../../settings/design/colors/colors';
import CollapsingList from '../../../../../../general-ui/collapsing-list/collapsing-list';
import BasicCard from '../../../../../../general-ui/basic-card/basic-card';
import Fonts from '../../../../settings/design/fonts/fonts';
import { FontHelmet } from '../../../../settings/design/fonts/font';
import { useState } from 'react';
import CustomCSS from '../../../../../../general-ui/edit-css/edit-css';
import { setEventCustomCss } from '../../../../../../../store/actions/admin/create-event';
import './theme.scss';

export default function ThemePanel(): JSX.Element {
	const {
		CreateEventReducer: {
			workingEvent
		}
	} = useSelector((state: EventsState) => state);
	const [editingCss, setEditingCss] = useState(false);
	const color = workingEvent?.settings.design.colors;
	const font = workingEvent?.settings.design.font;
	const dispatch = useDispatch();

	const editCustomCss = () => setEditingCss(true);

	return (
		<div className="theme-panel-container">
			<PanelHeader title="Theme" />
			<div className="panel-body">
				<CollapsingList
					label=""
					maxHeight={10000}
					customHeader={(toggleOpen, isOpen) => (
						<BasicCard p={15}>
							<div className="color">
								<div className="heading-row">
									<h6>{color?.title}</h6>
								</div>
								<div className="palette-row">
									<div
										style={{
											background: `${color?.colors.backgroundColor[0]}`,
											opacity: color?.colors.backgroundColor[1],
										}}
									/>
									<div
										style={{
											background: `${color?.colors.secondaryBackgroundColor[0]}`,
											opacity: color?.colors.secondaryBackgroundColor[1],
										}}
									/>
									<div
										style={{
											background: `${color?.colors.bodyTextColor[0]}`,
											opacity: color?.colors.bodyTextColor[1],
										}}
									/>
									<div
										style={{
											background: `${color?.colors.accentColor[0]}`,
											opacity: color?.colors.accentColor[1],
										}}
									/>
									<div
										style={{
											background: `${color?.colors.secondaryAccentColor[0]}`,
											opacity: color?.colors.secondaryAccentColor[1]
										}}
									/>
									<div
										style={{
											background: `${color?.colors.headingTextColor[0]}`,
											opacity: color?.colors.headingTextColor[1],
										}}
									/>
								</div>
							</div>
							<button className="no-style clear" onClick={() => toggleOpen()}>
								<Icon name={isOpen ? ICONS.KEYBOARD_ARROW_DOWN : ICONS.KEYBOARD_ARROW_RIGHT} color={COLORS.WHITE} size={16} />
							</button>
						</BasicCard>
					)}
				>
					<Colors />
				</CollapsingList>
				<CollapsingList
					label=""
					maxHeight={3000}
					customHeader={(toggleOpen, isOpen) => (
						<BasicCard p={15}>
							<div id={`font-${font?.font_pack}`}>
								<div className="font">
									<h6 style={{ fontFamily: `var(--var-head), sans-serif` }}>
										{font?.title}
									</h6>
									<p style={{ fontFamily: `var(--var-body), sans-serif` }}>
										{font?.description}
									</p>
								</div>

								{font ? <FontHelmet font={font} /> : null}
							</div>
							<button className="no-style clear" onClick={() => toggleOpen()}>
								<Icon name={isOpen ? ICONS.KEYBOARD_ARROW_DOWN : ICONS.KEYBOARD_ARROW_RIGHT} color={COLORS.WHITE} size={16} />
							</button>
						</BasicCard>
					)}
				>
					<Fonts />
				</CollapsingList>

				<div className="settings-block">
					<div className="settings-block-header">
						<h5>Event Custom CSS</h5>
						<button onClick={editCustomCss}><Icon name={ICONS.EDIT} size={16} color={COLORS.CYAN} /></button>
					</div>
					<pre>{workingEvent?.custom_css}</pre>
				</div>
			</div>

			<CustomCSS
				open={editingCss}
				onClose={() => setEditingCss(false)}
				onChange={(value) => dispatch(setEventCustomCss(value))}
				value={workingEvent?.custom_css ?? ""}
			/>
		</div>
	);
}
